import { STORAGE_KEY_FOR_SAMPLING } from 'integrations/sentry/sampling/defaults';
import { parseSampling } from 'integrations/sentry/sampling/parseSampling';
import { localStorage } from 'utils/localStorage';

type CacheOutput =
  | {
      value: number;
    }
  | undefined;

export function readCache(): CacheOutput {
  const cachedStringValue = localStorage.getPersistentItem(STORAGE_KEY_FOR_SAMPLING);

  const numberValue = cachedStringValue ? parseSampling(cachedStringValue) : undefined;

  if (typeof numberValue === 'number') {
    return {
      value: numberValue
    };
  }
  return undefined;
}

export function writeCache(value: string | number | null): void {
  if (typeof value === 'number') {
    localStorage.setPersistentItem(STORAGE_KEY_FOR_SAMPLING, value.toString());
  } else if (typeof value === 'string' && typeof parseSampling(value) === 'number') {
    localStorage.setPersistentItem(STORAGE_KEY_FOR_SAMPLING, value);
  } else {
    clearCache();
  }
}

export function clearCache(): void {
  localStorage.removePersistentItem(STORAGE_KEY_FOR_SAMPLING);
}
